/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-4371fb57.mjs';
import '../../_chunks/dep-31d34e52.mjs';
import '../../_chunks/dep-67e8723b.mjs';
import '../../_chunks/dep-0bf03d55.mjs';
import '../../_chunks/dep-5b5daf08.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-90d97bcb.mjs';
import '../../_chunks/dep-c8679a16.mjs';
import '../../_chunks/dep-939a74d6.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-e4f65bc4.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-1aa18f5f.mjs';
import '../../_chunks/dep-e09a06d8.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-0d3220b0.mjs';
import '../../_chunks/dep-895678a0.mjs';
import '../../_chunks/dep-b2bdc7b9.mjs';
import '../../_chunks/dep-0f45a6e0.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-35a4fd8d.mjs';
import '../../_chunks/dep-54378e60.mjs';
import '../../_chunks/dep-25b8bf4b.mjs';
import '../../_chunks/dep-c40264c0.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-0927ceb7.mjs';
import '../../_chunks/dep-f0bd05df.mjs';
import '../../config-provider/type.mjs';

function useCalendarClass(props, state) {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var body = computed(function () {
    return ["".concat(prefixClass.value), "".concat(prefixClass.value, "--").concat(props.theme)];
  });
  var panel = computed(function () {
    return ["".concat(prefixClass.value, "__panel"), "".concat(prefixClass.value, "__panel--").concat(state.curSelectedMode)];
  });
  var control = computed(function () {
    return ["".concat(prefixClass.value, "__control")];
  });
  var title = computed(function () {
    return ["".concat(prefixClass.value, "__title")];
  });
  var controlSection = computed(function () {
    return ["".concat(prefixClass.value, "__control-section")];
  });
  var controlSectionCell = computed(function () {
    return ["".concat(prefixClass.value, "__control-section-cell")];
  });
  var controlTag = computed(function () {
    return ["".concat(prefixClass.value, "__control-tag")];
  });
  var table = computed(function () {
    return ["".concat(prefixClass.value, "__table")];
  });
  var tableHead = computed(function () {
    return ["".concat(prefixClass.value, "__table-head")];
  });
  var tableHeadRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-row")];
  });
  var tableHeadCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-cell")];
  });
  var tableBody = computed(function () {
    return ["".concat(prefixClass.value, "__table-body")];
  });
  var tableBodyRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-row")];
  });
  return {
    body: body,
    panel: panel,
    control: control,
    title: title,
    controlSection: controlSection,
    controlSectionCell: controlSectionCell,
    controlTag: controlTag,
    table: table,
    tableHead: tableHead,
    tableHeadRow: tableHeadRow,
    tableHeadCell: tableHeadCell,
    tableBody: tableBody,
    tableBodyRow: tableBodyRow
  };
}
function useCalendarCellClass() {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var tableBodyCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell")];
  });
  var tableBodyCell4Now = computed(function () {
    return "".concat(prefixClass.value, "__table-body-cell--now");
  });
  var tableBodyCellDisplay = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-display")];
  });
  var tableBodyCellCsontent = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-content")];
  });
  return {
    tableBodyCell: tableBodyCell,
    tableBodyCell4Now: tableBodyCell4Now,
    tableBodyCellDisplay: tableBodyCellDisplay,
    tableBodyCellCsontent: tableBodyCellCsontent
  };
}

export { useCalendarCellClass, useCalendarClass };
//# sourceMappingURL=useCalendarClass.mjs.map
